import React, { SVGProps } from "react";
const SvgLifeScienceNatureAndAgriculture = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={29.204} viewBox="0 0 29.204 31.666" {...props}>
      <g data-name="Life Science, Nature and Agricul...">
        <g data-name="Group 359">
          <g data-name="Group 335">
            <g data-name="Group 333">
              <path
                data-name="Path 1072"
                d="M27.822 8.996c-1.755.033-8.254.541-8.959 6.187a.342.342 0 0 0 .332.352c7.164.661 8.712-4.692 9-6.167a.344.344 0 0 0-.373-.372Z"
                fill="#12b05e"
              />
            </g>
            <g data-name="Group 334">
              <path
                data-name="Path 1073"
                d="M6.688 8.996c1.755.033 8.254.541 8.959 6.187a.342.342 0 0 1-.332.352c-7.164.661-8.713-4.692-9-6.167a.344.344 0 0 1 .373-.372Z"
                fill="#12b05e"
              />
            </g>
          </g>
          <g data-name="Group 358">
            <path
              data-name="Path 1074"
              d="M17.438.58a.247.247 0 0 0-.42 0c-.918 1.446-4.331 7.511.2 11.436h.015c4.536-3.925 1.123-9.99.205-11.436Z"
              fill="#12b05e"
            />
            <g data-name="Group 357">
              <g data-name="Group 356">
                <path
                  data-name="Path 1075"
                  d="m10.287 21.085-2.839 2.264 9.78 4.683 9.78-4.683-2.839-2.264a11.169 11.169 0 0 0-13.882 0Z"
                  fill="#ce9875"
                />
                <g data-name="Group 336">
                  <path
                    data-name="Path 1076"
                    d="m20.35 22.654 2.839 2.264.216.157 3.6-1.725-2.839-2.264a11.174 11.174 0 0 0-13.02-.621 11.159 11.159 0 0 1 9.204 2.189Z"
                    fill="#c6865c"
                  />
                </g>
                <g data-name="Group 355">
                  <g data-name="Group 354">
                    <g data-name="Group 353">
                      <g data-name="Group 351">
                        <g data-name="Group 350">
                          <g data-name="Group 349">
                            <g data-name="Group 348">
                              <g data-name="Group 347">
                                <g data-name="Group 346">
                                  <g data-name="Group 345">
                                    <g data-name="Group 344">
                                      <g data-name="Group 343">
                                        <g data-name="Group 342">
                                          <g data-name="Group 341">
                                            <g data-name="Group 340">
                                              <g data-name="Group 339">
                                                <g data-name="Group 338">
                                                  <g data-name="Group 337">
                                                    <path
                                                      data-name="Path 1077"
                                                      d="m27.022 22.475-3.337 1.754a6.553 6.553 0 0 1-2.823.753l.043-.712a1.834 1.834 0 0 0-1.52-1.671l-3.729-.453a4.788 4.788 0 0 1-2.04-.895 14.839 14.839 0 0 0-2.83-1.221 5 5 0 0 0-3.87.455L1.66 23.432 5.779 30l2.247-1.993a1.361 1.361 0 0 1 1.319-.277l3.762 1.209a2.771 2.771 0 0 0 1.3.179l7.489-.768a2.813 2.813 0 0 0 1.308-.484l5.17-3.556a1.209 1.209 0 0 0 .18-1.525 1.069 1.069 0 0 0-1.532-.31Z"
                                                      fill="#ffddce"
                                                    />
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g data-name="Group 352" fill="#ffcbbe">
                        <path
                          data-name="Path 1078"
                          d="m1.679 23.423-.019.011.039.062Z"
                        />
                        <path
                          data-name="Path 1079"
                          d="M28.551 22.786a1.069 1.069 0 0 0-1.528-.311l-2.366 1.244s-.234.53-.495 1.094a3.277 3.277 0 0 1-2.023 1.809l-7.764.8a2.872 2.872 0 0 1-1.346-.185l-3.9-1.254a1.41 1.41 0 0 0-1.368.288l-2.8 2.433.816 1.3 2.247-1.993a1.361 1.361 0 0 1 1.319-.277l3.762 1.209a2.77 2.77 0 0 0 1.3.179l7.489-.768a2.812 2.812 0 0 0 1.308-.484l5.17-3.556a1.209 1.209 0 0 0 .179-1.528Z"
                        />
                      </g>
                    </g>
                  </g>
                  <path
                    data-name="Path 1080"
                    d="m6.785 30.462-1.081.624a.866.866 0 0 1-1.183-.317L.579 23.941a.866.866 0 0 1 .317-1.183l1.081-.624a.866.866 0 0 1 1.183.317l3.942 6.828a.866.866 0 0 1-.317 1.183Z"
                    fill="#ffcd27"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 1081"
          d="M28.941 22.534a1.532 1.532 0 0 0-2.159-.457l-.376.2-1.948-1.555a11.588 11.588 0 0 0-6.679-2.5A4.252 4.252 0 0 1 19 15.967a9.437 9.437 0 0 0 1.374.086 9.081 9.081 0 0 0 4.193-.926.464.464 0 1 0-.424-.825 8.41 8.41 0 0 1-4.178.815 52.987 52.987 0 0 1 7.608-5.165 7.582 7.582 0 0 1-1.8 3.152.464.464 0 0 0 .662.65 8.723 8.723 0 0 0 2.217-4.3.806.806 0 0 0-.839-.924c-4.548.087-8.841 2.031-9.411 6.593a.725.725 0 0 0 0 .134 5.752 5.752 0 0 0-.708.831V12.23a7.14 7.14 0 0 0 2.146-6.945A14.813 14.813 0 0 0 17.829.332a.711.711 0 0 0-1.2 0 14.813 14.813 0 0 0-2.008 4.953 7.141 7.141 0 0 0 2.145 6.945v3.781a5.792 5.792 0 0 0-.652-.752.726.726 0 0 0 0-.134c-.569-4.555-4.865-6.506-9.411-6.593a.806.806 0 0 0-.839.924 7.9 7.9 0 0 0 8.258 6.6 9.713 9.713 0 0 0 1.393-.087 4.243 4.243 0 0 1 1.224 2.246 11.582 11.582 0 0 0-5.314 1.538 10.216 10.216 0 0 0-.5-.165 5.485 5.485 0 0 0-4.23.5l-3.333 1.869a1.326 1.326 0 0 0-1.611-.219l-1.081.624a1.331 1.331 0 0 0-.487 1.816l3.937 6.824a1.329 1.329 0 0 0 1.816.487l1.081-.624a1.33 1.33 0 0 0 .5-1.785l.813-.722a.9.9 0 0 1 .87-.183l3.749 1.2a3.252 3.252 0 0 0 1.5.2l7.489-.769a3.289 3.289 0 0 0 1.523-.563c5.506-3.79 5.176-3.555 5.224-3.6a1.681 1.681 0 0 0 .256-2.109ZM26.392 9.562a53.288 53.288 0 0 0-6.877 4.726c.972-3.453 4.585-4.448 6.877-4.726ZM15 14.289a53.275 53.275 0 0 0-6.872-4.724c3.09.384 6.023 1.709 6.872 4.724ZM6.933 9.952a52.981 52.981 0 0 1 7.61 5.166c-5.338.186-7.07-3.313-7.61-5.166Zm11.991-4.5a6.31 6.31 0 0 1-1.234 5.444V1.961a12.96 12.96 0 0 1 1.234 3.491Zm-3.394 0a12.958 12.958 0 0 1 1.233-3.49v8.932a6.31 6.31 0 0 1-1.232-5.442Zm8.349 15.995 1.629 1.3-2.038 1.071a6.06 6.06 0 0 1-2.112.661l.011-.181a.46.46 0 0 0 0-.072 2.292 2.292 0 0 0-1.914-2.086h-.013l-3.723-.452c-1.179-.178-1.34-.695-3.166-1.487a10.722 10.722 0 0 1 11.326 1.246Zm4.2 2.5-5.137 3.534a2.359 2.359 0 0 1-1.092.4l-7.489.769a2.387 2.387 0 0 1-1.109-.159L9.49 27.282a1.832 1.832 0 0 0-1.769.372l-.67.594-1.5-2.6a.464.464 0 1 0-.8.464l1.957 3.39a.4.4 0 0 1-.147.549l-1.081.624a.4.4 0 0 1-.549-.147L.989 23.7a.4.4 0 0 1 .147-.549l1.081-.624a.4.4 0 0 1 .549.147l.9 1.556a.464.464 0 0 0 .8-.464l-.6-1.042 3.285-1.842a4.553 4.553 0 0 1 3.511-.416c2.88.862 3.226 1.875 4.934 2.13h.013l3.722.452a1.365 1.365 0 0 1 1.118 1.221l-.016.265-4.732.309a.464.464 0 0 0 .03.927h.031c5.008-.452 6.117-.073 8.149-1.141 3.541-1.863 3.342-1.753 3.389-1.786a.606.606 0 0 1 .871.184.744.744 0 0 1-.085.914Z"
        />
      </g>
    </svg>
  );
};
export default SvgLifeScienceNatureAndAgriculture;
